export const LinkGroups = [
  {
    groupLabel: 'Tax Saving Guides',
    links: [
      {
        label: 'Income Tax',
        link: 'https://cleartax.in/s/income-tax',
      },
      {
        label: 'Efiling Income Tax',
        link: 'https://cleartax.in/s/efiling-income-tax-return',
      },
      {
        label: 'Section 80 Deductions',
        link: 'https://cleartax.in/s/80c-80-deductions',
      },
      {
        label: 'Income Tax for NRI',
        link: 'https://cleartax.in/s/income-tax-for-nri',
      },
      {
        label: 'Capital Gains Income',
        link: 'https://cleartax.in/s/capital-gains-income',
      },
      {
        label: 'House Property',
        link: 'https://cleartax.in/s/house-property',
      },
      {
        label: 'Income Tax Verification',
        link: 'https://cleartax.in/s/income-tax-e-verification-evc',
      },
      {
        label: 'How to efile ITR',
        link: 'https://cleartax.in/s/how-to-efile-itr',
      },
      {
        label: 'Income Tax Refund status',
        link: 'https://cleartax.in/s/income-tax-refund',
      },
      {
        label: 'File TDS Returns',
        link: 'https://cleartax.in/tds',
      },
      {
        label: 'ITR',
        link: 'https://cleartax.in/s/itr',
      },
      {
        label: 'Income Tax Slab',
        link: 'https://cleartax.in/s/income-tax-slabs',
      },
      {
        label: 'Form 26AS',
        link: 'https://cleartax.in/s/view-form-26as-tax-credit-statement',
      },
      {
        label: 'What is Form 16',
        link: 'https://cleartax.in/s/what-is-form-16',
      },
      {
        label: 'Salary Income',
        link: 'https://cleartax.in/s/salary-income',
      },
      {
        label: 'How to File TDS Returns',
        link: 'https://cleartax.in/tds/guides',
      },
      {
        label: 'New Income Tax Portal',
        link: 'https://cleartax.in/s/new-income-tax-portal',
      },
      {
        label: 'Incometax.gov.in',
        link: 'https://cleartax.in/s/incometax-gov-in',
      },
    ],
  },
  {
    groupLabel: 'ClearTax Investment',
    links: [
      {
        label: 'Mutual Funds',
        link: 'https://cleartax.in/s/mutual-funds',
      },
      {
        label: 'SIP',
        link: 'https://cleartax.in/s/sip',
      },
      {
        label: 'ELSS Funds',
        link: 'https://cleartax.in/s/elss',
      },
      {
        label: 'How mutual funds are taxed?',
        link: 'https://cleartax.in/s/different-mutual-funds-taxed',
      },
      {
        label: 'Mutual Fund Analysis',
        link: 'https://cleartax.in/s/mutual-fund-analysis/',
      },
      {
        label: 'Types of Mutual Funds',
        link: 'https://cleartax.in/s/mutual-fund-types',
      },
    ],
  },
  {
    groupLabel: 'Invest in Best Funds 2021',
    links: [
      {
        label: 'Best Mutual funds',
        link: 'https://cleartax.in/s/best-mutual-funds',
      },
      {
        label: 'Best ELSS Funds',
        link: 'https://cleartax.in/s/best-elss-mutual-funds',
      },
      {
        label: 'Best Debt Funds',
        link: 'https://cleartax.in/s/best-debt-funds',
      },
      {
        label: 'Best Liquid Funds',
        link: 'https://cleartax.in/s/best-liquid-funds',
      },
      {
        label: 'Best SIP Plans',
        link: 'https://cleartax.in/s/best-sip-plans-mutual-fund',
      },
      {
        label: 'Best Midcap Funds',
        link: 'https://cleartax.in/s/best-mid-cap-mutual-funds',
      },
      {
        label: 'Best Large Cap Funds',
        link: 'https://cleartax.in/s/best-large-cap-mutual-funds',
      },
      {
        label: 'Best Multi Cap Funds',
        link: 'https://cleartax.in/s/best-multi-cap-funds',
      },
      {
        label: 'Best Small Cap Funds',
        link: 'https://cleartax.in/s/best-small-cap-mutual-funds',
      },
      {
        label: 'Top 10 mutual funds in India ',
        link: 'https://cleartax.in/s/top-10-mutual-funds-india',
      },
      {
        label: 'Best Equity Mutual Funds',
        link: 'https://cleartax.in/s/top-10-mutual-funds-india',
      },
      {
        label: 'Best Short Term Mutual Funds',
        link: 'https://cleartax.in/s/best-short-term-mutual-funds',
      },
      {
        label: 'Best Balanced Mutual Funds',
        link: 'https://cleartax.in/s/best-balanced-mutual-funds',
      },
      {
        label: 'Best Small Cap Mutual Funds',
        link: 'https://cleartax.in/s/best-small-cap-mutual-funds',
      },
      {
        label: 'Best Multicap Funds',
        link: 'https://cleartax.in/s/best-multi-cap-funds',
      },
      {
        label: 'Best Equity Funds',
        link: 'https://cleartax.in/s/best-equity-mutual-funds',
      },
      {
        label: 'Best Mid Cap Funds',
        link: 'https://cleartax.in/s/best-mid-cap-mutual-funds',
      },
    ],
  },
  {
    groupLabel: 'Invest in Best Funds 2021',
    links: [
      {
        label: 'Best Index Funds India',
        link: 'https://cleartax.in/s/best-index-funds-india',
      },
      {
        label: 'Best Dividend Yield Funds',
        link: 'https://cleartax.in/s/best-dividend-yield-mutual-funds',
      },
      {
        label: 'Best Sectoral Pharma Mutual Funds',
        link: 'https://cleartax.in/s/best-sectoral-pharma-mutual-funds',
      },
      {
        label: 'Best Sectoral Banking Mutual Funds',
        link: 'https://cleartax.in/s/best-sectoral-banking-mutual-funds',
      },
      {
        label: 'Best Sector Funds',
        link: 'https://cleartax.in/s/best-sector-funds',
      },
      {
        label: 'Best Contra Funds',
        link: 'https://cleartax.in/s/best-contra-mutual-funds',
      },
      {
        label: 'Best Value Funds',
        link: 'https://cleartax.in/s/best-value-funds',
      },
      {
        label: 'Best Hybrid Funds',
        link: 'https://cleartax.in/s/best-hybrid-funds',
      },
      {
        label: 'Best Multi Asset Allocation Mutual Funds',
        link: 'https://cleartax.in/s/best-multi-asset-allocation-mutual-funds',
      },
      {
        label: 'Best Dynamic Asset Allocation Mutual Funds',
        link: 'https://cleartax.in/s/best-dynamic-asset-allocation-mutual-funds',
      },
      {
        label: 'Best Arbitrage Funds',
        link: 'https://cleartax.in/s/best-arbitrage-funds',
      },
      {
        label: 'Best Ultra Short Mutual Funds',
        link: 'https://cleartax.in/s/best-ultra-short-mutual-funds',
      },
      {
        label: 'Best Dynamic Bond Funds',
        link: 'https://cleartax.in/s/best-dynamic-bond-funds',
      },
      {
        label: 'Best Gilt Funds',
        link: 'https://cleartax.in/s/best-gilt-funds',
      },
      {
        label: 'Best Credit Risk Funds',
        link: 'https://cleartax.in/s/best-credit-risk-funds',
      },
      {
        label: 'Best Low Duration Mutual Funds',
        link: 'https://cleartax.in/s/best-low-duration-mutual-funds',
      },
      {
        label: 'Best Dividend Yield Mutual Funds',
        link: 'https://cleartax.in/s/best-dividend-yield-mutual-funds',
      },
      {
        label: 'Best Contra Mutual Funds',
        link: 'https://cleartax.in/s/best-contra-mutual-funds',
      },
    ],
  },
  {
    groupLabel: 'Our Fund Partners',
    links: [
      {
        label: 'SBI Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/sbi-mutual-fund',
      },
      {
        label: 'HDFC Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/hdfc-mutual-fund',
      },
      {
        label: 'ICICI Prudential Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/icici-prudential-mutual-fund',
      },
      {
        label: 'Birla Sun Life Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/birla-sun-life-mutual-fund',
      },
      {
        label: 'Kotak Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/kotak-mutual-fund',
      },
      {
        label: 'Nippon India Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/nippon-india-mutual-fund',
      },
      {
        label: 'Axis mutual fund',
        link: 'https://cleartax.in/mutual-funds/axis-mutual-fund',
      },
      {
        label: 'UTI mutual fund',
        link: 'https://cleartax.in/mutual-funds/uti-mutual-fund',
      },
      {
        label: 'Idfc Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/idfc-mutual-fund',
      },
      {
        label: 'Dsp Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/dsp-mutual-fund',
      },
      {
        label: 'Franklin Templeton Mutual Fund',
        link: 'https://cleartax.in/s/franklin-templeton-mutual-fund',
      },
      {
        label: 'L&T Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/lt-mutual-fund',
      },
      {
        label: 'Mirae Asset Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/mirae-asset-mutual-fund',
      },
      {
        label: 'Tata Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/tata-mutual-fund',
      },
      {
        label: 'Edelweiss Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/edelweiss-mutual-fund',
      },
      {
        label: 'Invesco Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/invesco-mutual-fund',
      },
      {
        label: 'Sundaram Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/sundaram-mutual-fund',
      },
    ],
  },
  {
    groupLabel: 'Our Fund Partners',
    links: [
      {
        label: 'Canara Robeco Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/canara-robeco-mutual-fund',
      },
      {
        label: 'Motilal Oswal Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/motilal-oswal-mutual-fund',
      },
      {
        label: 'LIC Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/lic-mutual-fund',
      },
      {
        label: 'Hsbc Asset Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/hsbc-asset-mutual-fund',
      },
      {
        label: 'Baroda Pioneer Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/baroda-pioneer-mutual-fund',
      },
      {
        label: 'Ppfas Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/ppfas-mutual-fund',
      },
      {
        label: 'Bnp Paribas Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/bnp-paribas-mutual-fund',
      },
      {
        label: 'Principal Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/principal-mutual-fund',
      },
      {
        label: 'Dhfl Pramerica Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/dhfl-pramerica-mutual-fund',
      },
      {
        label: 'Quantum Asset Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/quantum-asset-mutual-fund',
      },
      {
        label: 'Quant Money Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/quant-money-mutual-fund',
      },
      {
        label: 'Mahindra Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/mahindra-mutual-fund',
      },
      {
        label: 'Union Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/union-mutual-fund',
      },
      {
        label: 'IDBI Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/idbi-mutual-fund',
      },
      {
        label: 'Jm Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/jm-mutual-fund',
      },
      {
        label: 'Iifl Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/iifl-mutual-fund',
      },
      {
        label: 'Boi Axa Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/boi-axa-mutual-fund',
      },
      {
        label: 'Indiabulls Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/indiabulls-mutual-fund',
      },
      {
        label: 'Taurus Asset Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/taurus-asset-mutual-fund',
      },
      {
        label: 'Shriram Mutual Fund',
        link: 'https://cleartax.in/mutual-funds/shriram-mutual-fund',
      },
    ],
  },
  {
    groupLabel: 'Calculators',
    links: [
      {
        label: 'Mutual Fund Calculator',
        link: 'https://cleartax.in/s/mutual-fund-calculator',
      },
      {
        label: 'SIP Calculator',
        link: 'https://cleartax.in/s/sip-calculator',
      },
      {
        label: 'EMI Calculator',
        link: 'https://cleartax.in/s/emi-calculator',
      },
      {
        label: 'PPF Calculator',
        link: 'https://cleartax.in/s/ppf-calculator',
      },
      {
        label: 'RD Calculator',
        link: 'https://cleartax.in/s/rd-calculator',
      },
      {
        label: 'Tax Saving Calculator',
        link: 'https://cleartax.in/s/tax-saving-calculator',
      },
      {
        label: 'NPS Calculator',
        link: 'https://cleartax.in/s/fd-calculator',
      },
      {
        label: 'FD Calculator',
        link: 'https://cleartax.in/s/fd-calculator',
      },
      {
        label: 'Income Tax Calculator',
        link: 'https://cleartax.in/paytax/taxcalculator',
      },
      {
        label: 'Home Loan EMI Calculator',
        link: 'https://cleartax.in/s/home-loan-emi-calculator',
      },
      {
        label: 'GST Number Search ',
        link: 'https://cleartax.in/gst-number-search/',
      },
      {
        label: 'HSN Code Fider',
        link: 'https://cleartax.in/s/gst-hsn-lookup',
      },
      {
        label: 'IFSC Code Search',
        link: 'https://cleartax.in/ifsc-code/',
      },
      {
        label: 'Gold Rates Today',
        link: 'https://cleartax.in/f/gold-rate/india',
      },
    ],
  },
  {
    groupLabel: 'Popular Investment Plans',
    links: [
      {
        label: 'Save Your Taxes Plans',
        link: 'https://cleartax.in/save/plan/19',
      },
      {
        label: 'Aggressive Growth Plans',
        link: 'https://cleartax.in/save/plan/26',
      },
      {
        label: 'Grow Rich Plans',
        link: 'https://cleartax.in/save/plan/21',
      },
      {
        label: 'Balanced Growth Plans',
        link: 'https://cleartax.in/save/plan/25',
      },
      {
        label: 'Quick Savings',
        link: 'https://cleartax.in/save/plan/21',
      },
      {
        label: 'Better than FD Plans',
        link: 'https://cleartax.in/save/plan/20',
      },
    ],
  },
  {
    groupLabel: 'ClearTax',
    links: [
      {
        label: 'Contact Us',
        link: 'https://cleartax.in/Meta/contact',
      },
      {
        label: 'About Us',
        link: 'https://cleartax.in/s/about-us',
      },
      {
        label: 'Careers',
        link: 'https://cleartax.in/s/career',
      },
      {
        label: 'Media & Press',
        link: 'https://cleartax.in/Meta/Press',
      },
      {
        label: 'Income tax e-filing',
        link: 'https://cleartax.in/income-tax-efiling',
      },
      {
        label: 'GST Software',
        link: 'https://cleartax.in/gst',
      },
      {
        label: 'ClearTax Chronicles',
        link: 'https://news.cleartax.in/',
      },
      {
        label: 'Expert Assisted Tax Filing',
        link: 'https://cleartax.in/s/pricing',
      },
      {
        label: 'TaxCloud (Direct Tax Software)',
        link: 'https://taxcloudindia.com/',
      },
      {
        label: 'Mutual Fund App',
        link: 'https://play.google.com/store/apps/details?id=in.cleartax.consumer2',
      },
      {
        label: 'Download ClearApp',
        link: 'https://play.google.com/store/apps/details?id=com.cleartax.clear&hl=en',
      },
      {
        label: 'Download ClearTax Pro',
        link: 'https://play.google.com/store/apps/details?id=in.cleartax.pro&hl=en',
      },
      {
        label: 'Clear Library',
        link: 'https://cleartax.in/v/tax-library/',
      },
      {
        label: 'Fintech Glossary',
        link: 'https://cleartax.in/g/terms/',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./constants/footerLinks.ts